import { render, staticRenderFns } from "./ticketLists.vue?vue&type=template&id=08964956&"
import script from "./ticketLists.vue?vue&type=script&lang=js&"
export * from "./ticketLists.vue?vue&type=script&lang=js&"
import style0 from "./ticketLists.vue?vue&type=style&index=0&id=08964956&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports